/**
 * Features:
 * - PortalIcon base: enforces the §14.4.4 contract — 24px grid, 1.7px stroke, rounded
 *   caps/joins, `currentColor` so parents pick `var(--hp-ink)` or `var(--hp-accent)`.
 *   Decorative by default (`aria-hidden`); pass `title` for `role="img"` + `<title>`.
 */
import type { ReactNode, SVGProps } from 'react';

export interface PortalIconProps extends Omit<SVGProps<SVGSVGElement>, 'children'> {
  /** Rendered square size in px (grid stays 24). Default 24. */
  size?: number;
  /** Accessible name; omit for decorative icons inside labelled controls. */
  title?: string;
  children?: ReactNode;
}

export function PortalIcon({ size = 24, title, children, ...rest }: PortalIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}
